import { useEffect } from "react";

/**
 * Custom hook to handle clicks outside of Joy UI Menu components
 * This is a workaround for the known Joy UI bug where menus don't close on outside clicks
 *
 * @param menuAnchor - The anchor element for the menu (HTMLElement | null)
 * @param onClose - Function to call when menu should close
 * @param anchorElement - Optional anchor element to exclude from outside click detection
 */
export const useMenuOutsideClick = (
  menuAnchor: HTMLElement | null,
  onClose: () => void,
  anchorElement?: HTMLElement | null,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuAnchor) {
        const target = event.target as Element;
        const isMenuClick = target.closest("[data-menu]");
        const isAnchorClick =
          anchorElement &&
          (anchorElement === target || anchorElement.contains(target));

        if (!isMenuClick && !isAnchorClick) {
          onClose();
        }
      }
    };

    if (menuAnchor) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuAnchor, onClose, anchorElement]);
};
